<template>
  <div
    :class="[
      'sidebar-logo',
      logoMode,
      className,
      { collapse: isCollapse, fixed: fixed }
    ]"
  >
    <transition name="sidebarLogo">
      <router-link :to="toPath" class="flexC">
        <img v-if="logo" class="logo flex-1" :src="logo" />
        <template v-if="isPng(logoName)">
          <img
            v-if="logoName && (logoMode !== 'fold' || !isCollapse)"
            class="logo-name flex-1"
            :src="logoName"
          />
        </template>
        <template v-else>
          <p
            v-if="logoName && (logoMode !== 'fold' || !isCollapse)"
            class="logo-name flex-1"
          >
            {{ logoName }}
          </p>
        </template>
      </router-link>
    </transition>
  </div>
</template>

<script>
import '../../../../lib/styles/components/Logo.scss'

export default {
  name: 'Logo',
  props: {
    // 是否展开
    isCollapse: {
      type: Boolean,
      required: true
    },
    logo: {
      type: String,
      default: ''
    },
    logoName: {
      type: String,
      default: ''
    },
    toPath: {
      type: String,
      default: '/'
    },
    fixed: {
      type: Boolean,
      default: true
    },
    logoMode: {
      type: String,
      default: 'expand'
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {},
  methods: {
    isPng(str) {
      const regBase = new RegExp(
        /^\s*data:([a-z]+\/[a-z0-9-+.]+(;[a-z-]+=[a-z0-9-]+)?)?(;base64)?,([a-z0-9!$&',()*+;=\-._~:@\/?%\s]*?)\s*$/i
      )
      const reg = new RegExp(/.(gif|jpg|jpeg|png|webp|GIF|JPG|PNG|WEBP)$/, 'g')
      return reg.test(str) || regBase.test(str)
    }
  }
}
</script>
